import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
	gtmId: 'GTM-WJRT6RGV',
	dataLayerName: 'DataLayer',
};

if (process.env.REACT_APP_STAGE === 'prod')
	TagManager.initialize(tagManagerArgs);

ReactDOM.createRoot(document.getElementById('root')).render(
	<BrowserRouter>
		<App />
	</BrowserRouter>
);
